// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__22-mg","alert":"SettungsInbox_alert__3m4Wb"};